import Flex from "@irati/ui/src/Flex"
import Form from "@irati/ui/src/Form"
import styled, {css} from "styled-components"

export const Image = styled.img`
  height: 140px;
  width: 140px;
  margin-bottom: 15px;
  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
  height: 200px;
  width: 200px;
`}
`
export const Separator = styled.span`
  display: block;
  height: 1px;
  width: 100%;
  ${({theme}) => css`
    background: ${theme.colors.greys.mediumLight};
  `}
  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    width: 1px;
    height: 100%;
    margin-right: 1rem;
  `}
`

export const StyledFlex = styled(Flex)`
  flex-direction: column;
  gap: 3rem;
  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
  flex-direction: row;
  gap: 0;
  padding: ${theme.spacing.three} 0;
`}
`
export const DatePickerContainer = styled(Flex)`
  ${({theme}) => css`
    justify-content: center;
    padding: ${theme.spacing.oneAndHalf};
    border: 1px solid ${theme.colors.greys.light};
    border-bottom: 0;
    background: white;
    box-shadow: ${theme.shadows.low};
    > div {
      width: 100%;
    }
    .react-datepicker__day--today {
      font-weight: 400;
    }
    .react-datepicker {
      border: 0;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      width: 100%;
      gap: ${theme.spacing.two};
      font-size: ${theme.spacing.two};
      .react-datepicker__day:not(.react-datepicker__day--disabled),
      .react-datepicker__day-name,
      .react-datepicker__current-month,
      .react-datepicker__time-list-item:not(.react-datepicker__time-list-item--disabled) {
        color: ${theme.colors.utility.ink};
      }
      .react-datepicker__current-month {
        font-weight: 500;
        padding-top: ${theme.spacing.half};
        font-size: ${theme.spacing.two};
      }
      .react-datepicker__day-name {
        font-size: ${theme.spacing.oneAndHalf};
        font-weight: bold;
        text-transform: uppercase;
      }
      .react-datepicker__day,
      .react-datepicker__day-name {
        width: 30px;
        height: 30px;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        ${theme.mediaQueries.minWidthMedia.tablet`
        width: 40px;
        height: 40px;
      `}
      }
      .react-datepicker__header--time {
        display: none;
      }
      .react-datepicker__day--selected {
        background: transparent;
        color: initial;
        font-weight: bold;
        border-radius: ${theme.spacing.twelve};
        padding: 6px;
        border: 1px solid ${theme.colors.utility.ink};
      }
      div.react-datepicker__time-container,
      div.react-datepicker__time-box {
        width: 100%;
        margin: unset;
      }
      div.react-datepicker__time-box ul.react-datepicker__time-list {
        ${theme.mediaQueries.maxWidthMedia.tablet`
        max-height: 180px;
      `}
      }
      div.react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item {
        height: auto;
        padding: ${theme.spacing.oneAndHalf};
        white-space: nowrap;
        text-align: left;
      }
      div.react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected,
      div.react-datepicker__time-box
        ul.react-datepicker__time-list
        li.react-datepicker__time-list-item:hover:not(.react-datepicker__time-list-item--disabled) {
        background: ${theme.colors.utility.highlight};
        color: ${theme.colors.utility.ink};
        font-weight: 400;
      }
      .react-datepicker__header {
        border: 0;
        padding: 0;
        background: transparent;
      }
      .react-datepicker__day-names {
        margin-top: ${theme.spacing.one};
      }
      .react-datepicker__month {
        margin: 0;
      }
      .react-datepicker__month-container,
      .react-datepicker__time-container {
        border: 1px solid ${theme.colors.greys.light};
        border-radius: 2px;
      }
      .react-datepicker__month-container {
        width: 100%;
        box-sizing: content-box;
        padding: ${theme.spacing.oneAndHalf};
        ${theme.mediaQueries.minWidthMedia.tablet`
        width: auto;
      `}
      }
      .react-datepicker__time-container {
        flex: 1;
      }
    }
  `}
`
export const StyledForm = styled(Form)`
  flex: 1;
  .form-control {
    border-right: 0;
  }
  span.input-group .form-control + .input-group-addon {
    box-shadow: none;
    border-left: 0;
    padding: 0;
  }
`
